module.exports = __webpack_public_path__ + "img/PLC-Logo@2x.7fc7c961.png";